// Pixel da Meta — só o CompleteRegistration do cadastro (plano Free).
//
// O consentimento NÃO é pedido aqui: quem decide é o banner do site público
// (scripts/analytics-snippet.js), que grava `bz_consent_mkt` num cookie em
// .bzapper.com.br. Sem esse cookie = 'granted' (recusou, nunca passou pelo site ou
// veio pelo bzapper.com), o fbevents.js nem é baixado. A Política de Privacidade
// declara este evento — se ele mudar, a política muda junto.

const PIXEL_ID = '1121393346975353';
const PROD_HOSTNAME = 'app.bzapper.com.br';

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

function hasMarketingConsent(): boolean {
  if (typeof window === 'undefined' || window.location.hostname !== PROD_HOSTNAME) return false;
  return document.cookie.split(';').some((c) => c.trim() === 'bz_consent_mkt=granted');
}

function loadPixel(): Fbq {
  if (window.fbq) return window.fbq;
  const n = function (...args: unknown[]) {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  } as Fbq;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  window.fbq = n;
  window._fbq = window._fbq || n;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  n('set', 'autoConfig', false, PIXEL_ID); // sem eventos automáticos: só o que a política declara
  n('init', PIXEL_ID);
  return n;
}

/** Cadastro concluído (toda conta nova nasce no Free). No-op sem consentimento de marketing. */
export function trackCompleteRegistration(): void {
  if (!hasMarketingConsent()) return;
  try {
    loadPixel()('track', 'CompleteRegistration', { content_name: 'free', status: true });
  } catch {
    // Rastreamento nunca pode atrapalhar o cadastro.
  }
}
